// extracted by mini-css-extract-plugin
export default {"content":"Dialogs_content__61eUk","cancelButton":"Dialogs_cancelButton__Ho-2B","confirmButton":"Dialogs_confirmButton__0nRrs"};